module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "generated-style",
    attrs: {
      "id": "weitgmeack"
    }
  }, [_c('p', {
    staticClass: "chapter-head",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "body",
    attrs: {
      "xml:lang": "en-us"
    }
  }, [_vm._v("There are so many people to acknowledge for their help and moral support. I wish to thank all my friends who assisted me in one way or another. Special thanks to my lovely wife, Karen, and my children, Angela, Bryan Keith, Misty, Forest, Jr., Neal Nassor, and Miranda, for their patience and understanding while I relived many bad memories during the process of writing this book. Thanks to Cynthia Jardon, feature journalist for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alexandria Town Talk.")]), _vm._v(" Thanks to Brenda Kaiser of KALB-TV in Alexandria and her daughters Krystal, Kari, and Kasee. Finally, thanks to Robert Harris, MD, DD, PhD, international vice president and dean of the Institute of Divine Metaphysical Research, who seemed to read my mind when I was ready to quit and always had the right words of encouragement to convince me to soldier on.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dcae803","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/WEITGMeACK.vue
// module id = 75
// module chunks = 0